import type { ReactNode } from "react";

interface TagProps {
  label: string;
  icon?: string;
  variant?: "primary" | "accent" | "secondary";
}

const variantClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export default function Tag({ label, icon, variant = "secondary" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${variantClass[variant]}`}
    >
      {icon ? (
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className={`${icon} text-[12px]`}></i>
        </span>
      ) : null}
      {label}
    </span>
  );
}

export function MetaText({ children, icon }: { children: ReactNode; icon?: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-foreground-500 md:text-sm">
      {icon ? (
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={`${icon} text-[13px]`}></i>
        </span>
      ) : null}
      {children}
    </span>
  );
}